module.exports = __webpack_public_path__ + "img/7.3.TP.8efd8ba1.png";